import "./DatasetImgItem.less"
import Checkbox from "antd/es/checkbox/Checkbox";
import Images from "../../utils/Images";

type DatasetImgItemProps = {
    img: string;
    isChecking: boolean;
    isChecked: boolean;
    width: number;
    height: number;
    text: string;
    onCheckedChange: (a: boolean) => void;
    onManualTagClick: () => void;
    onDeleteClick: () => void;
};

export const DatasetImgItem = (props: DatasetImgItemProps): React.ReactElement => {
    const isChecking = props.isChecking;
    return <div className="dataset-img-item">
        <div className="dataset-img-item-img" data-hoverable={!isChecking} style={{"--img": `url(${props.img})`} as React.CSSProperties} onClick={() => props.onCheckedChange(!props.isChecked)}>
            {!isChecking && <div className="dataset-img-item-mask">
                <img src={Images.deleteIcon2} onClick={props.onDeleteClick}></img>
            </div>}
        </div>
        <div className="dataset-img-item-text no-scrollbar">{props.text}</div>
        <div className="dataset-img-item-top">
            {props.isChecking && <Checkbox checked={props.isChecked} onChange={e => props.onCheckedChange(e.target.checked)}></Checkbox>}
            <span>{`${props.width} * ${props.height}`}</span>
        </div>
        {!isChecking && <div className="dataset-img-item-edit-wrap">
            <img src={Images.edit} onClick={props.onManualTagClick}></img>
        </div>}
    </div>;
};